export const ERROR = {
	ERROR_404: "Página não encontrada!",
	WITHOUT_PERMISSION_TITLE: "Você não tem permissões suficientes para visualizar essa página.",
	WITHOUT_PERMISSION_DESCRIPTION: "Entre em contato com o administrador para mais informações.",
};